export { useResponsive } from "./useResponsive";
//# sourceMappingURL=index.js.map